import * as FileSaver from 'file-saver'
import moment from 'moment-timezone'
import * as XLSX from 'xlsx-js-style'
import { styleTableSheet } from 'utils/excelStyle'

const escapeCsvValue = (value) => {
  if (value === null || value === undefined) {
    return '""'
  }

  return `"${String(value).replace(/"/g, '""')}"`
}

const getExportColumns = (columns) => columns.filter((col) => !col.skipExport)

const getColumnTitle = (col) => {
  if (typeof col.name === 'string') return col.name

  if (typeof col.name === 'object') {
    return col?.name?.props?.children ?? ''
  }

  return ''
}

const getCellValue = (column, row) => {
  if (column.exportValue) {
    return column.exportValue(row)
  }

  if (typeof column.selector === 'function') {
    return column.selector(row)
  }

  if (typeof column.selector === 'string') {
    return row?.[column.selector] ?? ''
  }

  return ''
}

export const handleDownloadCSV = async (
  fetchFn,
  queryParams,
  setIsDownloading,
  columns,
) => {
  try {
    if (setIsDownloading) setIsDownloading(true)

    const result = await fetchFn({
      ...queryParams,
      isexport: true,
    }).unwrap()

    const data = result?.items || []

    const exportColumns = getExportColumns(columns)

    let csvString =
      exportColumns
        .map((col) => escapeCsvValue(getColumnTitle(col)))
        .join(',') + '\n'

    data.forEach((row) => {
      csvString +=
        exportColumns
          .map((col) => escapeCsvValue(getCellValue(col, row)))
          .join(',') + '\n'
    })

    const blob = new Blob([csvString], {
      type: 'text/csv;charset=utf-8;',
    })

    FileSaver.saveAs(blob, `Data_Anggota_${moment().format('YYYY-MM-DD')}.csv`)
  } catch (err) {
    console.error(err)
  } finally {
    if (setIsDownloading) setIsDownloading(false)
  }
}

export const handleDownloadExcel = async (
  fetchFn,
  queryParams,
  setIsDownloading,
  columns,
) => {
  try {
    if (setIsDownloading) setIsDownloading(true)

    const result = await fetchFn({
      ...queryParams,
      isexport: true,
    }).unwrap()

    const data = result?.items || []

    const exportColumns = getExportColumns(columns)

    const header = exportColumns.map(getColumnTitle)

    const body = data.map((row) =>
      exportColumns.map((col) => getCellValue(col, row)),
    )

    const ws = XLSX.utils.aoa_to_sheet([header, ...body])

    const wb = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(wb, styleTableSheet(ws), 'data')

    const excelBuffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
    })

    const finalData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    })

    FileSaver.saveAs(
      finalData,
      `Data_Anggota_${moment().format('YYYY-MM-DD')}.xlsx`,
    )
  } catch (err) {
    console.error(err)
  } finally {
    if (setIsDownloading) setIsDownloading(false)
  }
}
